@if (!settingsReady) {
  <p role="alert">Widget settings or placement options are unavailable. Reload this page before editing Sitewide Unlock.</p>
}
<form [formGroup]="form" autoTrackUnsavedChanges>
  <section class="setting-section" aria-labelledby="siteWideUnlockEnabled-label">
    <div class="setting-row">
      <h3 id="siteWideUnlockEnabled-label"><label for="siteWideUnlockEnabled">Sitewide Unlock</label></h3>
      <div class="toggle">
        <p-toggleswitch inputId="siteWideUnlockEnabled" formControlName="siteWideUnlockEnabled" ariaLabel="Sitewide Unlock"></p-toggleswitch>
        <span aria-hidden="true">@if (form.controls.siteWideUnlockEnabled.value) { On } @else { Off }</span>
      </div>
    </div>
    <p id="siteWideUnlockEnabled-description">Let shoppers unlock private offers across eligible website pages.</p>
  </section>
  <section class="setting-section" aria-labelledby="bannerEnabled-label">
    <div class="setting-row">
      <h3 id="bannerEnabled-label"><label for="bannerEnabled">Unlock banner</label></h3>
      <div class="toggle">
        <p-toggleswitch inputId="bannerEnabled" formControlName="bannerEnabled" ariaLabel="Unlock banner"></p-toggleswitch>
        <span aria-hidden="true">@if (form.controls.bannerEnabled.value) { On } @else { Off }</span>
      </div>
    </div>
    <p id="bannerEnabled-description">Appears below navigation before the shopper unlocks.</p>
  </section>
  <section class="setting-section" aria-labelledby="unlockPopupEnabled-label">
    <div class="setting-row">
      <h3 id="unlockPopupEnabled-label"><label for="unlockPopupEnabled">Pre-unlock pop-up teaser</label></h3>
      <div class="toggle">
        <p-toggleswitch inputId="unlockPopupEnabled" formControlName="unlockPopupEnabled" ariaLabel="Pre-unlock pop-up teaser"></p-toggleswitch>
        <span aria-hidden="true">@if (form.controls.unlockPopupEnabled.value) { On } @else { Off }</span>
      </div>
    </div>
    <p id="unlockPopupEnabled-description">Invites shoppers to unlock private offers. Displays only before unlocking.</p>
    <div class="placements">
      <div class="placement">
        <label for="unlockDesktop">Desktop placement<span class="visually-hidden"> for pre-unlock pop-up teaser</span></label>
        <p-select inputId="unlockDesktop" formControlName="unlockDesktop" [options]="desktopOptions" placeholder="Select a desktop position"
                  optionLabel="label" optionValue="id" appendTo="body" [style]="{width: '100%'}"></p-select>
      </div>
    </div>
    <p class="placement-note">On mobile, the teaser appears at the bottom center.</p>
  </section>
  <section class="setting-section" aria-labelledby="navigationPopupEnabled-label">
    <div class="setting-row">
      <h3 id="navigationPopupEnabled-label"><label for="navigationPopupEnabled">Post-unlock navigation</label></h3>
      <div class="toggle">
        <p-toggleswitch inputId="navigationPopupEnabled" formControlName="navigationPopupEnabled" ariaLabel="Post-unlock navigation"></p-toggleswitch>
        <span aria-hidden="true">@if (form.controls.navigationPopupEnabled.value) { On } @else { Off }</span>
      </div>
    </div>
    <p id="navigationPopupEnabled-description">Returns shoppers to the offer leaderboard. Displays only after unlocking.</p>
    <div class="placements">
      <div class="placement">
        <label for="navigationDesktop">Desktop placement<span class="visually-hidden"> for post-unlock navigation</span></label>
        <p-select inputId="navigationDesktop" formControlName="navigationDesktop" [options]="desktopOptions" placeholder="Select a desktop position"
                  optionLabel="label" optionValue="id" appendTo="body" [style]="{width: '100%'}"></p-select>
      </div>
    </div>
    <p class="placement-note">On mobile, navigation appears at the bottom right.</p>
  </section>
  @if (settingsReady && form.hasError('siteWidePlacement')) {
    <p class="placement-note" role="alert">Select a valid desktop position for each enabled pop-up before saving.</p>
  }
</form>
<p class="placement-note">The pre-unlock pop-up teaser and post-unlock navigation never display at the same time, so they will not overlap each other—even if you select the same position.</p>
